import { gql } from "@apollo/client";

const SAVE_VISITA_CUMPLIMIENTO_INDICACION_AP = gql`
    mutation saveVisitaCumplimientoIndicacionAP($input: AddVisitaCumplimientoIndicacionInput!, $idTeleEnfermeria: Int!){
        saveVisitaCumplimientoIndicacionAP(input: $input, idTeleEnfermeria: $idTeleEnfermeria) {
            idCumplimientoIndicacion
        }
    }
`;

export default SAVE_VISITA_CUMPLIMIENTO_INDICACION_AP;

export const adaptAddVisitaCumplimientoIndicacionInput = (data) => ({
  idTeleEnfermeria: data?.idTeleEnfermeriaAP,
  input: {
    idCumplimientoIndicacion: data?.idCumplimientoIndicacion || 0,
    cambioIndicacionSemana: !!data?.cambioIndicacion,
    dificultadCumplimiento: data?.dificultadCumplimiento,
    realizaEscalonamiento: !!data?.realizaEscalonamiento,
    indicacionActual: data?.indicacionRealizando,
    volumenDiario: data?.volumenPorDia?.toString(),
    bolsaUtilizada: data?.bolsaUtilizando,
    velocidadPasaje: data?.velocidadBolsa,
    horarioConexion: data?.horaConexion,
    quienRealizaCI: data?.quienLoHace,
    procesoConexionDesconexion: data?.procesoConexion,
    complementaViaOral: !!data?.complementaViaOral
  }
});